export function createCustomComponentList() {
  const list = document.getElementById("custom-component-list");

  Object.keys(window.JTComponents).forEach((key) => {
    if (key === "version" || key === "env") return;
    list.insertAdjacentHTML("beforeend", `<li>${key}</li>`);
  });
}
